import React from 'react'
import createReactClass from 'create-react-class'
import FlywheelFailed from './flywheel/flywheelfailed'
import CloudwaysFailed from './cloudways/cloudwaysfailed'
import WPEngineFailed from './wpengine/wpenginefailed'
import WPCOMFailed from './wpcom/wpcomfailed'
import MgFailed from './mg/mgfailed'

const Failed = createReactClass({
	render() {
		const { migrate, history } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelFailed migrate={migrate} />
		case ORIGIN.CLOUDWAYS:
			return <CloudwaysFailed migrate={migrate} />
		case ORIGIN.WPENGINE:
			return <WPEngineFailed migrate={migrate} />
		case ORIGIN.AUTOMATTIC:
			return <WPCOMFailed migrate={migrate} history={history} />
		default:
			return <MgFailed migrate={migrate} history={history} />
		}
	}
})

export default Failed
